export const QA_COMMENTS = true
export const LEG_COMMENTS = true

export const COMMENTS = (QA_COMMENTS || LEG_COMMENTS) && true
export const COMMENTS_ADMIN = (QA_COMMENTS || LEG_COMMENTS) && true
export const ACCOUNT_DETAILS = true
export const ACCOUNT_ENCRYPTION = (QA_COMMENTS || LEG_COMMENTS) && true
export const ACCOUNT_HISTORY = true
export const ACCOUNT_PASSWORD_CHANGE = true
export const ACCOUNT_PREFERENCES = true
export const PRECEDENTS = true
export const CA_SELECTION = true
export const LEG_SELECTION = true
export const QA_SELECTION = true
export const INSTRUCTION_VIDEO = true
export const DEALWATCH = true
export const PREVENT_MULTIPLE_LOGIN = false

export const LEGISLATION_TAKEOVER_CODE = false
export const LEGISLATION_KEY_PICKS = true
export const LEGISLATION_FOLDERS = true
export const LEGISLATION_PARTIAL_NOTES = true

export const ARCHIVE_FLAVOUR = true

export const AUTOMATED_PRECEDENT_LISTINGS = true
export const DOCUMENT_DRAFTER = true
